import queryMultiTenantOrganizationDetails from '@ms/yammer-graphql/dist/operations/queryMultiTenantOrganizationDetails.graphql';

import { GraphqlApiRequest, ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../..';
import { normalizeMultiTenantOrganizationDetails } from '../../normalization/graphql/normalizeMultiTenantOrganizationDetails';
import { reportError } from '../../telemetry';
import { PromiseThunkAction } from '../../types';

import {
  MultiTenantOrganizationDetailsClientLoadFulfilledAction,
  MultiTenantOrganizationDetailsClientLoadPendingAction,
  MultiTenantOrganizationDetailsClientLoadRejectedAction,
  MultiTenantOrganizationDetailsClientLoadResponse,
} from './actions.types';
import { getMultiTenantOrganizationDetailsStatus } from './selectors';

const loadMultiTenantOrganizationDetailsPending = (): MultiTenantOrganizationDetailsClientLoadPendingAction => ({
  type: 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_PENDING',
});

const loadMultiTenantOrganizationDetailsFulfilled = (
  payload: MultiTenantOrganizationDetailsClientLoadFulfilledAction['payload']
): MultiTenantOrganizationDetailsClientLoadFulfilledAction => ({
  type: 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_FULFILLED',
  payload,
});

const loadMultiTenantOrganizationDetailsRejected = (
  error: unknown
): MultiTenantOrganizationDetailsClientLoadRejectedAction => ({
  type: 'MULTI_TENANT_ORGANIZATION_DETAILS.LOAD_REJECTED',
  payload: {
    error,
  },
  error: true,
});

type Load = () => PromiseThunkAction<void>;
export const load: Load = () => async (dispatch, getState) => {
  const state = getState();
  const status = getMultiTenantOrganizationDetailsStatus(state);

  if (status === 'pending') {
    return;
  }

  const request: GraphqlApiRequest = getGraphqlApiRequest({
    body: {
      operationName: 'MultiTenantOrganizationDetails',
      query: queryMultiTenantOrganizationDetails,
    },
  });
  const lifecycle: ManagedApiLifecycle<MultiTenantOrganizationDetailsClientLoadResponse> = {
    pending: () => loadMultiTenantOrganizationDetailsPending(),
    fulfilled: (response) =>
      loadMultiTenantOrganizationDetailsFulfilled(normalizeMultiTenantOrganizationDetails(response)),
    rejected: (error) => loadMultiTenantOrganizationDetailsRejected(error),
  };
  const action = managedApiAction({ request, lifecycle });

  try {
    await dispatch(action);
  } catch (error) {
    reportError({ error });
  }
};
